module.exports = __webpack_public_path__ + "img/truck.f51baf3a.png";